module.exports = __webpack_public_path__ + "img/title_7.a2c9590c.png";